import(/* webpackMode: "eager" */ "/app/src/app/[locale]/Health-Lifestyle/page.tsx");
